import { useContext } from 'react'
import { Card, CardBody, Row } from 'reactstrap'
import { useContactOtherInfoFormSelectOptions } from '../../pages/Contacts/hooks'
import FormMainContainer from '../Common/FormMainContainer'
import FormSideContainer from '../Common/FormSideContainer'
import RecursiveForm from '../RecursiveForm'
import ContactFormOtherInfoContext from './ContactFormOtherInfoContext'

const ContactFormOtherInfoTab = (props) => {
    const { children, formik, inputs, subform, inputComponents, tabs, activeTab, handleTabChange, contact, contactType } = props
    const { selectOptions, isPending: selectOptionsLoading } = useContactOtherInfoFormSelectOptions(contact, contactType)

    return (
        <ContactFormOtherInfoContext.Provider
            value={{
                formik,
                inputs,
                subform,
                inputComponents,
                tabs,
                activeTab,
                handleTabChange,
                selectOptions,
                selectOptionsLoading,
            }}
        >
            <Row>{children}</Row>
        </ContactFormOtherInfoContext.Provider>
    )
}

export const ContactFormOtherInfoTabSide = () => {
    const { inputs, formik, subform, selectOptions, selectOptionsLoading, inputComponents } = useContext(ContactFormOtherInfoContext)

    return (
        <FormSideContainer>
            {inputs?.sideForm?.length && (
                <Card>
                    <CardBody>
                        <RecursiveForm
                            inputs={inputs?.sideForm}
                            subform={subform}
                            formik={formik}
                            selectOptions={selectOptions}
                            selectOptionsLoading={selectOptionsLoading}
                            inputComponents={inputComponents}
                        />
                    </CardBody>
                </Card>
            )}
        </FormSideContainer>
    )
}

export const ContactFormOtherInfoTabMain = () => {
    const { inputs, formik, subform, selectOptions, selectOptionsLoading, inputComponents, tabs, activeTab, handleTabChange } =
        useContext(ContactFormOtherInfoContext)

    return (
        <FormMainContainer tabs={tabs} activeTab={activeTab} handleTabChange={handleTabChange}>
            <RecursiveForm
                inputs={inputs?.mainForm}
                subform={subform}
                formik={formik}
                selectOptions={selectOptions}
                selectOptionsLoading={selectOptionsLoading}
                inputComponents={inputComponents}
            />
        </FormMainContainer>
    )
}

export default ContactFormOtherInfoTab
